import { Typography } from "@mui/material";
import styled from "styled-components";
import { Switch } from "ctech-react-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: 25px;
`;

export const Content = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 505px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px;
`;

export const Title = styled(Typography)`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Separator = styled.div`
  margin: 0 5px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 100%;
  background: ${({ theme }) => theme.palette.background.default};
  gap: 16px;
`;

export const WorkingHourContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 12px;
  transition: height 0.3s ease;
`;

export const WorkingHourRowView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: space-between;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 12px;
  padding-right: 0px;
`;

export const WorkingHourRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const WeekDayTypography = styled(Typography)<{ isActive: boolean }>`
  min-width: 95px;
  color: ${({ theme, isActive }) =>
    isActive ? theme.palette.primary.main : theme.palette.text.secondary};
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const LegendTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const HoursContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-left: 10px;

  .MuiOutlinedInput-root {
    width: 70px !important;
  }
`;

export const HoursContainerView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  justify-content: space-between;
  margin-left: 25px;
  gap: 15px;

  .MuiOutlinedInput-root {
    width: 110px !important;
  }
`;

export const HourContainer = styled.div``;

export const ActionsContainer = styled.div`
  width: 100%;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  > button {
    height: 42px !important;
    border-radius: 20px;
    height: 30px;
  }
`;

export const CustomSwitch = styled(Switch)`
  margin-left: 15px;
`;

export const ContainerButton = styled.div<{
  isActive: boolean;
  enabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  gap: 5px;
  margin-left: auto;
  margin-right: 10px;
  height: 38px;
  opacity: ${({ enabled }) => (enabled ? "0.5" : "1")};
  border-radius: 4px;
  color: ${({ isActive }) => (isActive ? "#2e7d32" : "#000000")};
  background: ${({ isActive }) =>
    isActive ? "rgba(23, 188, 23, 0.15)" : "rgba(167, 167, 167, 0.15)"};
  span {
    margin-left: 0;
  }
`;

export const ContainerDisabled = styled.div`
  display: flex;
  width: 100%;
  height: 46px;
  background: rgba(167, 167, 167, 0.1);
  align-items: center;
  justify-content: flex-end;
  margin-right: 5px;
  border-radius: 4px;

  div {
    margin-right: 5px;
  }
`;

export const ContainerIcon = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerInputHours = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
